import { ROLES } from '@api/users/constants';

export const ARTICLE_TYPE = {
  NEWS: {
    key: 'news',
    label: 'News',
  },
  REPORTS: {
    key: 'reports',
    label: 'Reports',
  },
  PREVIEWS: {
    key: 'previews',
    label: 'Previews',
  },
  PRESS_RELEASES: {
    key: 'pressreleases',
    label: 'Press releases',
  },
  SPIKES: {
    key: 'spikes',
    label: 'Spikes',
  },
  FEATURES: {
    key: 'features',
    label: 'Features',
  },
  SERIES: {
    key: 'series',
    label: 'Series',
  },
  LIFESTYLE: {
    key: 'lifestyle',
    label: 'Lifestyle',
  },
  PERFORMANCE: {
    key: 'performance',
    label: 'Performance',
  },
  CULTURE: {
    key: 'culture',
    label: 'Culture',
  },
  PLAQUE: {
    key: 'plaque',
    label: 'Plaque',
    visibleFor: [ROLES.EDITOR],
  },
};

export const ARTICLE_TYPES = Object.values(ARTICLE_TYPE);
export const ARTICLE_TYPE_NAME_MAP = ARTICLE_TYPES.reduce(
  (acc, { key, label }) => ({
    ...acc,
    [key]: label,
    [label]: label,
  }),
  {},
);

export const ARTICLE_LAYOUT = {
  WITH_1_COLUMN: {
    key: 1,
    label: '1 column',
  },
  WITH_2_COLUMNS: {
    key: 2,
    label: '2 columns',
  },
};
export const ARTICLE_LAYOUTS = Object.values(ARTICLE_LAYOUT);

export const FILTER_OPTION = {
  ALL: {
    key: '',
    label: 'All articles',
  },
  ...ARTICLE_TYPE,
  BE_ACTIVE: {
    key: 'personalBest',
    label: 'Personal best',
  },
  EVENT: {
    key: 'eventArticle',
    label: 'Event',
  },
};
export const FILTER_OPTIONS = Object.values(FILTER_OPTION);

export const DATE_OPTION = {
  ALL: {
    key: '',
    label: 'All time',
  },
  THIS_WEEK: {
    key: 'thisWeek',
    label: 'This week',
  },
};
export const DATE_OPTIONS = Object.values(DATE_OPTION);

export const MAP_DATE_OPTION_TO_API = {
  [DATE_OPTION.ALL.key]: {},
  [DATE_OPTION.THIS_WEEK.key]: {
    fromThisWeek: true,
  },
};
